import { CUSTOM_FILTERS } from "@/config/list";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { ListFilters } from "@/types/list";

type MostDownstreamFilterProps = {
	filter: ListFilters;
};

const OPTIONS: { label: string; value: boolean }[] = [
	{ label: "All points", value: false },
	{ label: "Downstream only", value: true },
];

export const MostDownstreamFilter = ({ filter }: MostDownstreamFilterProps) => {
	const isMostDownstream = (filter.getFilter(CUSTOM_FILTERS.isMostDownstream) as boolean | undefined) ?? false;

	const onChange = (selected: boolean) => {
		if (selected) {
			filter.setFilter(CUSTOM_FILTERS.isMostDownstream, true);
		} else {
			filter.clearFilter(CUSTOM_FILTERS.isMostDownstream);
		}
	};

	const activeLabel = OPTIONS.find(option => option.value === isMostDownstream)?.label ?? "All points";

	return (
		<div className="relative z-10">
			<div className="flex flex-col space-y-1">
				<span className="text-xs font-medium text-muted-foreground">Downstream</span>
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Button variant="outline" className="justify-start">
							<span
								className={!isMostDownstream ? "font-semibold text-muted-foreground" : "font-semibold"}
							>
								{activeLabel}
							</span>
							<ChevronDown className="ml-2 h-4 w-4 opacity-50" />
						</Button>
					</DropdownMenuTrigger>
					<DropdownMenuContent align="start">
						{OPTIONS.map(option => (
							<DropdownMenuItem
								key={option.label}
								onSelect={() => onChange(option.value)}
								className={option.value === isMostDownstream ? "font-semibold bg-muted" : ""}
							>
								{option.label}
							</DropdownMenuItem>
						))}
					</DropdownMenuContent>
				</DropdownMenu>
			</div>
		</div>
	);
};
